module.exports = __webpack_public_path__ + "static/media/high-banner.5bb8b239.jpg";